module.exports = __webpack_public_path__ + "static/media/pfSense_step6.bf61b459.png";